<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>
<script>
// import jwtDecode from 'jwt-decode';
import {mapState} from 'vuex'

const default_layout = "default";

export default {
  name: 'app',
  computed: {
    ...mapState(['theme']),
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    }
  },
  data(){
    return{
      isMobile: false,
      window:{},
      root:{style:{}},
      dark: false,
    }
  },
  watch:{
    window:{
      handler(nv){
        if(nv.width < 600){
          this.isMobile = true
          // console.log(nv.width)
        }else{
          this.isMobile = false
        }
      },
      deep: true
    },
    // dark: {
    //   handler: function() {
    //     this.setTheme()
    //   }
    // }
  },
  methods:{
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    // setTheme(){
    //   console.log(this.theme)
    //   if(this.theme == 'light'){
    //   }else if(this.theme=='dark'){
    //     this.root.style.setProperty("--primary", "#F0592A");
    //     this.root.style.setProperty("--secondary", "#ffdb66");
    //     this.root.style.setProperty("--tertiary", "#bf370d");
    //     this.root.style.setProperty("--success", "#49d049");
    //     this.root.style.setProperty("--bg-default", "#545454");
    //     this.root.style.setProperty("--dark", "#fff");
    //     this.root.style.setProperty("--bg-secondary", "#dedede");
    //     this.root.style.setProperty("--link-light", "#11607E");
    //     this.root.style.setProperty("--link-dark", "#4bbbe7");
    //     this.root.style.setProperty("--bg-dark", "#000");
    //   }
    // }
  },
  created() {
    this.window = {
      'width': window.innerWidth,
      'height': window.innerHeight
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted: function() {
    this.root = document.documentElement;
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
html, body{
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  min-height: 100%;
  min-width: 100%;
  background: var(--bg-default);
  overscroll-behavior-y: contain;
}
#app {
  font-family: "Altis", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overscroll-behavior-y: contain;
}
body[data-theme='dark'] html,
body[data-theme='dark'] .body,
body[data-theme='dark'] #app{
  background-color: var(--dark);
  color: var(--bg-default);
}
:root{
    --primary: #6366F1;;
    --secondary: #FFBE00;
    --danger: #FF5B78;
    --success: #85e085;
    --health: #32BA7C;
    --bg-default: #f4f6fa;
    --dark: #000;
    --bg-secondary: #dedede;
    --link-light: #3463DC;
    --link-dark: #11607E;
    --bg-dark: #545454;
}
.danger{
  color: #FF5B78;
}
@font-face {
  font-family: "Altis";
  font-weight: 400;
  src: local("Altis"),
   url(./assets/fonts/Altis.otf) format("opentype");
}
@font-face {
 font-family: 'Berlin Sans FB Bold';
 font-weight: 400;
 src: local(''),
      url(./assets/fonts/berlin.ttf) format('ttf'), /* Chrome 26+, Opera 23+, Firefox 39+ */
}
@font-face {
  font-family: "Altis Bold";
  font-weight: 600;
  src: local("Altis"),
   url(./assets/fonts/Altis-Bold.otf) format("opentype");
}
/* INPUTS */

.input-group{
  display:flex;
  border-radius: 15px;
  background-color: #f7f7fb;
  padding: .6rem 2rem;
  padding-left: 1rem;
  width: 90%;
  height: 3rem;
  font-size: .8rem;
  margin: 1rem 0;
  transition: 1s;
  position: relative;
}
.input-icon{
  width: 1.2rem;
}
.long{
  background-repeat: no-repeat;
  background-position: right center;
  background-origin: content-box;
  background-size: 1.5rem 1.5rem;
}
.input-group input{
  border:none;
  outline: none;
  background-color: #F7F7FB;
}

.login-input{
  border:none;
  font-family: "Altis";
  background-color: #F7F7FB;
  border-left: 1.5px solid #B4BDD5;
  padding: .6rem 2rem;
  padding-left: 1rem;
  width: 80%;
  font-size: .8rem;
  margin: .2rem 0;
  margin-left: .3rem;
  transition: 1s;
}
.heading-text{
  font-size: 1rem;
  width: 80%;
  margin: auto;
  font-weight:bold;
}
.login-input:focus{
  border:none;
  outline: none;
}
.input2{
  height: 40px;
  width: 90%;
  max-width: 280px;
  margin: 0 auto;
}
.input2 input{
  font-size: 1rem;
}
.isChecked{
  border: 5px solid var(--secondary);
}
.isChecked-text{
  /* margin-top: -10px; */
  /* transform: translateY(-5px); */
}
/* BUTTONS */
.btn{
  border: none;
  border-radius: 10px;
  width: 50%;
  margin: 1rem auto;
  cursor:pointer;
  transition: 1s;
  background-color: var(--primary);
  color:  #fff;
  padding: .6rem 3rem;
  font-size: 1rem;
  display: flex;
  outline:none;
  flex-direction: row;
  justify-content: center;
  font-weight:bold;
  align-items:center;
  font-family: "Altis";
}
.btn-alt{
  background-color: #fff;
  color: var(--primary);
}
.btn-alt-2{
  border: 2px solid var(--primary);
}
.btn-login{
  background-color: var(--primary);
  text-align:center;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  padding: .5rem 1rem;
  color: #fff;
  width: 80%;
  height: 3rem;
  margin: 2rem auto;
  font-family: "Altis";
  cursor: pointer;
  transition: 1s;
}

.login-input:focus{
  border:none;
  outline: none;
}
.success-alert{
  border: 2px solid #138013;
  border-radius: 10px;
  margin: 1.3rem;
  background-color: #85e085;
  color: #138013;
  font-size: .9rem;
  padding: .5rem 2rem;
}
.text-primary{
  color: var(--primary);
}
body[data-theme='dark']  .input-group{
  border-color: #000;
  color: #fff;
}

body[data-theme='dark'] .login-input{
  background-color: #222;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  html, body{
    background-color: #fff;
  }
}
</style>
